var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['placeholder-image', 'ratio', ("ratio-" + _vm.ratio)]},[_c('div',{staticClass:"image-wrapper"},[_c('b-icon',{staticClass:"image-icon",style:(("height: " + _vm.size + "%;")),attrs:{"icon":"image-placeholder"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }